export default __webpack_public_path__ + "static/cashflow8-dc17d0b39cd87f5b31f42bae756d69bf.jpg";